import type { RcFile } from "antd/es/upload/interface";

export default (img: RcFile, callback: (url: string) => void) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result as string));
  if (img) {
    reader.readAsDataURL(img);
  }
};
